import React from "react";
import { ReactComponent as Loupe } from "../../assets/images/svg/loupe.svg";
import Input from "../input/Input";

export const SearchBar = (props) => {
  const { keyword, setKeyword, className } = props;
  const customClass = className ?? "";

  return (
    <div
      className={`flex items-center self-start relative mt rounded w-full ${customClass}`}
    >
      <Input
        type="text"
        classOverride={true}
        placeholder="Search product"
        className={`px-14 w-full text-txtBlack bg-white placeholder-txtGray focus:outline-none h-14 object-contain rounded-2xl shadow-containerShadow `}
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
      />
      <Loupe className="absolute left-5" />
    </div>
  );
};
